<div class="modal-header">
    <h4 class="modal-title">Mały ekran</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">

    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            <div class="text-center mt-3 mb-3">
                <img src="assets/img/computer_mobile.svg" width="200">
            </div>
            <p>Fodimi działa perfekcyjnie na komputerach i tabletach.</p>
            <p>Na urządzeniach z małym ekranem nie doświadczych tego samego :( </p>
            <p>Oczywiście korzystaj z systemu do woli, jednakże zalecamy wypróbować nas w pełni na większym ekranie</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="text-center mb-3">
                <button type="button" class="btn w-sm btn-outline-danger waves-effect" (click)="modal.close(true)">Dzięki, jestem tego świadomy!</button>
            </div>
        </div> <!-- end col -->
    </div>
</div>
